(function () {
    'use strict';

    function optionsQuestionConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/optionsQuestionConfiguration.html',
            link: function (scope) {

            }
        };
    }

    optionsQuestionConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('optionsQuestionConfiguration', optionsQuestionConfiguration);
})();
